export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11338.638dee51.jpg";